export function getOrderIds(orders) {
  return (orders || []).map(order => order?.core?.orderId).filter(Boolean);
}

export function getNewOrderIds(previousOrderIds, orders) {
  const previous = new Set(previousOrderIds || []);
  return getOrderIds(orders).filter(orderId => !previous.has(orderId));
}

export const NOTIFIED_ORDER_IDS_STORAGE_KEY = 'cp-notified-order-ids';

const NOTIFIED_ORDER_IDS_LIMIT = 200;

// Multiple open dashboard tabs each poll and detect the same new orders; this shared
// registry lets the first tab to detect an order claim it so the others stay quiet.
export function claimUnnotifiedOrderIds(orderIds) {
  if (typeof window === 'undefined' || !orderIds.length) return orderIds;

  try {
    const stored = JSON.parse(window.localStorage.getItem(NOTIFIED_ORDER_IDS_STORAGE_KEY)) || [];
    const notified = new Set(stored);
    const unnotified = orderIds.filter(orderId => !notified.has(orderId));

    if (unnotified.length) {
      window.localStorage.setItem(
        NOTIFIED_ORDER_IDS_STORAGE_KEY,
        JSON.stringify([...stored, ...unnotified].slice(-NOTIFIED_ORDER_IDS_LIMIT))
      );
    }
    return unnotified;
  } catch (_error) {
    return orderIds;
  }
}
